import { onLivewireProcessed } from '../utilities/livewire-hooks';

const LOAN_TRACK_SELECTOR = '[data-loan-track]';

let initialized = false;

const getSeenIds = () => {
    if (!window.seenLoanIds) {
        window.seenLoanIds = new Set();
    }

    return window.seenLoanIds;
};

const parseTrackData = (el) => {
    if (el.__loanTrackData) return el.__loanTrackData;

    const raw = el.dataset.loanTrack;
    if (!raw) return null;

    try {
        el.__loanTrackData = JSON.parse(raw);
        return el.__loanTrackData;
    } catch (error) {
        console.warn('loan-observer: invalid data-loan-track', error);
        return null;
    }
};

const getTrackId = (data) => data?.item_id ?? data?.id ?? null;

const buildPayload = (data) => ({
    items: [{
        item_id: getTrackId(data),
        item_name: data?.item_name ?? '',
        affiliation: data?.affiliation ?? '',
        index: data?.index ?? '',
        item_brand: data?.item_brand ?? '',
        item_category: data?.item_category ?? '',
    }],
});

const sendViewItem = (data) => {
    if (!window.GTM || typeof window.GTM.send !== 'function') return false;
    return window.GTM.send('view_item', buildPayload(data)) === true;
};

const initLoanObserver = () => {
    if (initialized) return;
    initialized = true;

    const start = () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const data = parseTrackData(entry.target);
                if (!data) return;

                const trackId = getTrackId(data);
                if (!trackId) return;

                const seenIds = getSeenIds();
                if (seenIds.has(trackId)) {
                    observer.unobserve(entry.target);
                    return;
                }

                if (sendViewItem(data)) {
                    seenIds.add(trackId);
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.3 });

        const observeAll = () => {
            const seenIds = getSeenIds();

            document.querySelectorAll(LOAN_TRACK_SELECTOR).forEach(el => {
                if (el.dataset.loanObserved === '1') return;

                const data = parseTrackData(el);
                if (!data) return;

                const trackId = getTrackId(data);
                if (!trackId) return;

                if (seenIds.has(trackId)) {
                    el.dataset.loanObserved = '1';
                    return;
                }

                el.dataset.loanObserved = '1';
                observer.observe(el);
            });
        };

        observeAll();
        onLivewireProcessed(() => {
            observeAll();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
};

export default initLoanObserver;
